import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import axios from 'axios'
import url from '@/config/url'

import Forbidden from '@/pages/forbidden'
import Login from '@/pages/login'
import Logout from '@/pages/logout'

import User from '@/pages/user'
import UserRoutes from './user'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'UserAbout' }
    },
    {
      path: '/u',
      name: 'User',
      meta: {
        requireAuth: true
      },
      component: User,
      // redirect: { name: 'UserAbout' },
      children: UserRoutes.routes
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        requireAuth: false
      },
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      meta: {
        requireAuth: false
      },
      component: Logout
    },
    {
      path: '/503',
      name: 'Forbidden',
      component: Forbidden
    },
    {
      path: '*',
      redirect: { name: 'Forbidden' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requireAuth = to.matched.some(record => record.meta.requireAuth)
  const jwt = Vue.localStorage.get('jwt')
  const lit = Vue.localStorage.get('lit')
  if (requireAuth) {
    store.commit('loader/open')
    axios.post(`${url.api}auth/t/jwt`, { token: jwt }).then(res => {
      store.commit('loader/close')
      if (res.data.success) {
        next()
      } else {
        next({
          path: '/login',
          query: lit ? { t: lit } : {}
        })
      }
    }).catch(() => {
      next({
        path: '/login',
        query: lit ? { t: lit } : {}
      })
    })
  } else {
    next()
  }
})

export default router